export * from "ce/pages/Editor/NavigationSettings/LogoInput";
import { default as CE_LogoInput } from "ce/pages/Editor/NavigationSettings/LogoInput";
export default CE_LogoInput;
